import React from 'react';
import ReactDOM from 'react-dom';
import Papa from 'papaparse';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './App.css';

// Style for the table containers
const tableContainerStyle = {
  maxHeight: '400px', // Max height of the container
  width: 'calc(50% - 10px)', // Width of the container
  overflow: 'auto', // Enable scrolling
};


class PopupComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankErrorData: [],
      configErrorData: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchApiBankData();
    this.fetchApiConfigData();
  }

  componentDidUpdate(prevProps) {
    // Check if any relevant prop has changed and fetch new data if needed
    if (this.props.data.merchant !== prevProps.data.merchant ||
        this.props.data.acqBank !== prevProps.data.acqBank ||
        this.props.data.startDate !== prevProps.data.startDate ||
        this.props.data.endDate !== prevProps.data.endDate ||
        this.props.data.tenderMode !== prevProps.data.tenderMode) {
      this.fetchApiBankData();
      this.fetchApiConfigData();
    }
  }

  getCurrentFormattedDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  fetchApiBankData = () => {
    const { merchant, acqBank, startDate, endDate, tenderMode } = this.props.data;
    const currentDate = this.getCurrentFormattedDate();
    let apiEndpoint;
    const type = 'bank'; // or dynamically set based on some condition or prop
    if (startDate === currentDate && endDate === currentDate) {
      // Use the endpoint for the current date
      apiEndpoint = `http://localhost:5000/celldatareal?start=${startDate}&end=${endDate}&ci_tender_mode=${tenderMode}&merchant_name=${encodeURIComponent(merchant)}&acq_bank_name=${encodeURIComponent(acqBank)}&type=${type}`;
    } else {
      // Use the regular endpoint for other dates
      apiEndpoint = `http://localhost:5000/celldata?start=${startDate}&end=${endDate}&ci_tender_mode=${tenderMode}&merchant_name=${encodeURIComponent(merchant)}&acq_bank_name=${encodeURIComponent(acqBank)}&type=${type}`;
    }
    //const apiEndpoint = `http://localhost:5000/celldata?start=${startDate}&end=${endDate}&ci_tender_mode=${tenderMode}&merchant_name=${encodeURIComponent(merchant)}&acq_bank_name=${encodeURIComponent(acqBank)}&type=${type}`;

    fetch(apiEndpoint)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text(); // Get the response text (CSV data)
      })
      .then(csvText => {
        // Parse the CSV data
        Papa.parse(csvText, {
          header: true, // Indicates that the CSV file has a header row
          dynamicTyping: true, // Automatically convert numeric values to numbers
          complete: (result) => {
            this.setState({ bankErrorData: result.data });
          }
        });
      })
      .catch(error => {
        console.error('Error fetching data from API:', error);
        this.setState({ bankErrorData: [] }); // Reset the errorData to an empty array on error
      });
  };

  fetchApiConfigData = () => {
    const { merchant, acqBank, startDate, endDate, tenderMode } = this.props.data;
    const type = 'config'; // or dynamically set based on some condition or prop
    const currentDate = this.getCurrentFormattedDate();
    let apiEndpoint;
    if (startDate === currentDate && endDate === currentDate) {
      // Use the endpoint for the current date
      apiEndpoint = `http://192.168.0.170/api/flask/report/celldatareal?start=${startDate}&end=${endDate}&ci_tender_mode=${tenderMode}&merchant_name=${encodeURIComponent(merchant)}&acq_bank_name=${encodeURIComponent(acqBank)}&type=${type}`;
    } else {
      // Use the regular endpoint for other dates
      apiEndpoint = `http://192.168.0.170/api/flask/report/celldata?start=${startDate}&end=${endDate}&ci_tender_mode=${tenderMode}&merchant_name=${encodeURIComponent(merchant)}&acq_bank_name=${encodeURIComponent(acqBank)}&type=${type}`;
    }
    fetch(apiEndpoint)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text(); // Get the response text (CSV data)
      })
      .then(csvText => {
        // Parse the CSV data
        Papa.parse(csvText, {
          header: true, // Indicates that the CSV file has a header row
          dynamicTyping: true, // Automatically convert numeric values to numbers
          complete: (result) => {
            this.setState({ configErrorData: result.data });
          }
        });
      })
      .catch(error => {
        console.error('Error fetching data from API:', error);
        this.setState({ configErrorData: [] }); // Reset the errorData to an empty array on error
      });
  };

  onRowClickedBank = (row) => {
    this.setState({ isLoading: true }, () => {
      this.onRowClicked(row, 'bank');
    });
  };

  onRowClickedConfig = (row) => {
    this.setState({ isLoading: true }, () => {
      this.onRowClicked(row, 'config');
    });
  };

  onRowClicked = (row, type) => {
    this.setState({ isLoading: true });
    const { merchant, acqBank, startDate, endDate, tenderMode } = this.props.data; // Destructure the needed props

    const apiEndpoint = `http://192.168.0.170/api/flask/report/export?start=${startDate}&end=${endDate}&ci_tender_mode=${tenderMode}&merchant_name=${encodeURIComponent(merchant)}&acq_bank_name=${encodeURIComponent(acqBank)}&type=${type}`;

    // Perform the API call using the data appended to the URL
    fetch(apiEndpoint)
    .then(response => response.blob())
    .then(blob => {
      // Handle the file response and initiate download
      const fileURL = URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.href = fileURL;
      tempLink.setAttribute('download', 'error_details.xlsx'); // Set a default filename for the download
      tempLink.click();
      URL.revokeObjectURL(fileURL); // Clean up the object URL
    })
    .catch(error => {
      console.error('Error fetching or downloading file:', error);
    })
    .finally(() => this.setState({ isLoading: false }));
  };

  // Define the column definitions for bank error data
  bankColumnDefs = [
    { headerName: "Bank Error Reason", field: 'co_reason_message', cellStyle: { textAlign: 'center' },sortable: true },
    {
      headerName: "Percentage",
      field: 'Bank Error Percentage',
      sortable: true,
      cellStyle: { textAlign: 'center' }, // Center align text
      valueFormatter: params => {
        // Check if the value is a number before calling toFixed
        if (typeof params.value === 'number') {
          return `${params.value.toFixed(1)}%`;
        }
        // If the value is undefined or not a number, return a default string
        return 'N/A';
      }
    },
    { headerName: "Transaction Count", field: 'Count Bank Errors', cellStyle: { textAlign: 'center' }, sortable: true }
  ];

  // Define the column definitions for config error data
  configColumnDefs = [
    { headerName: "Config Error Reason", field: 'co_reason_message', cellStyle: { textAlign: 'center' },sortable: true },
    {
      headerName: "Percentage",
      field: 'Config Error Percentage',
      sortable: true,
      cellStyle: { textAlign: 'center' },
      valueFormatter: params => {
        // Check if the value is a number before calling toFixed
        if (typeof params.value === 'number') {
          return `${params.value.toFixed(1)}%`;
        }
        // If the value is undefined or not a number, return a default string
        return 'N/A';
      }
    },
    { headerName: "Transaction Count", field: 'Count Config Errors', cellStyle: { textAlign: 'center' }, sortable: true }
  ];

  // Define styles for the popup inner component
  popupInnerStyle = {
    width: '80%',
    height: 'auto',
    maxWidth: '1200px',
    margin: '50px auto',
    padding: '20px',
    overflow: 'hidden',
  };

  // Default column properties
  defaultColDef = {
    resizable: true,
    filter: true,
    flex: 1,
    minWidth: 100,
  };

  render() {
    const { bankErrorData, configErrorData, isLoading } = this.state;
    const { data, onClose } = this.props;

    console.log('Popup data:', data);
    console.log('isLoading:', isLoading)

    // Create the popup JSX
    return(
      <div className="popup">
        <div className="popup-inner" style={this.popupInnerStyle}>
        <button onClick={onClose}>Close</button>
          {/* Check if data.value is not empty and contains '|' */}
          {data.value && data.value.includes('|') ? (
            <div>
              <h2>{data.colHeader} : {data.value}</h2>
              {/* Split the value and display with legends */}
              <div>
                {(() => {
                  const parts = data.value.split('|');
                  const firstPart = parts[0]?.trim();
                  const secondPart = parts[1]?.trim();
                  return (
                    <div>
                      <p>Bank Error: {firstPart}, Config Error: {secondPart}, Transaction Count: {data.transactionCount}</p>
                    </div>
                  );
                })()}
              </div>
            </div>
          ) : (
            <h2>{data.colHeader} : Data not available</h2>
          )}

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start', gap: '20px' }}>
            <div className="ag-theme-alpine" style={tableContainerStyle}>
              <AgGridReact
                rowData={bankErrorData}
                columnDefs={this.bankColumnDefs}
                defaultColDef={this.defaultColDef}
                domLayout='autoHeight'
                onRowClicked={this.onRowClickedBank} // Handle row clicks
              />
            </div>
            <div className="ag-theme-alpine" style={tableContainerStyle}>
              <AgGridReact
                rowData={configErrorData}
                columnDefs={this.configColumnDefs}
                defaultColDef={this.defaultColDef}
                enableSorting={true}
                domLayout='autoHeight'
                onRowClicked={this.onRowClickedConfig} // Handle row clicks
              />
            </div>
          </div>
        </div>
      </div>
    );
    /*const portalRoot = document.getElementById('portal-root');
    if (!portalRoot) {
      // If the portal-root doesn't exist, you might want to handle it
      // For example, you can return null or some fallback UI
      console.error('The portal-root does not exist in the DOM.');
      return null; // or return <SomeFallbackUI />;
    }
    return ReactDOM.createPortal(
      <>
        {isLoading && (
          <div className="loading-overlay">
            Preparing data and downloading CSV file...
          </div>
        )}
        {popupJSX}
      </>,
      document.getElementById('portal-root')
    );*/
  }

}

export default PopupComponent;